import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    View,
    Text,
    TouchableOpacity,
    StyleSheet
} from 'react-native'

import { currencyFormat } from '../../lib/index'
import Charts from '../charts/index'
import STYLES from '../../constants/styles'

export default class Card extends Component {
    static propTypes = {
        data: PropTypes.shape({
            aggregation: PropTypes.oneOfType([
                PropTypes.object,
                PropTypes.array
            ]),
            sum: PropTypes.object,
            status: PropTypes.string
        }).isRequired,
        offsetKeyDate: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        cardStyle: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        title: PropTypes.string,
        onPress: PropTypes.func
    }

    static defaultProps = {
        data: []
    }

    render() {
        let { data, offsetKeyDate, title, cardStyle, primaryColor, selectedColor, ...props } = this.props

        return (
            <TouchableOpacity style={[styles.container, cardStyle]}
                activeOpacity={0.8}
                onPress={props.onPress}
                pointerEvents={'box-only'}
                {...props}>

                <View style={{ flex: 1 }}>
                    <View style={styles.header}>
                        <Text style={styles.headerMoneyText}>
                            {currencyFormat(data.sum[title])}
                        </Text>
                        <Text style={styles.headerText}>
                            {title}
                        </Text>
                    </View>
                </View>

                <View style={{ flex: 6 }}>
                    <Charts
                        data={data.aggregation[title]}
                        offsetKeyDate={offsetKeyDate}
                        layout={{ width: ~~(0.8 * cardStyle.width), height: ~~(0.5 * cardStyle.height) }}
                        primaryColor={primaryColor}
                        selectedColor={selectedColor}
                        noAxisLabels
                        noSelectBox />
                </View>

                <View style={{ flex: 1 }}>
                    <View style={styles.button}>
                        <Text style={styles.buttonText}>
                            More Info
                        </Text>
                    </View>
                </View>
            </TouchableOpacity>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: STYLES.CARD_BACKGROUND_COLOR
        , borderWidth: 2
        , borderColor: 'white'
        , borderRadius: 20
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'flex-start'
        , paddingHorizontal: 30
        , paddingVertical: 20
        , shadowColor: STYLES.SHADOW_COLOR
        , shadowRadius: 40
        , shadowOffset: { width: 4, height: 6 }
    },
    header: {
        alignSelf: 'flex-start'
    },
    headerText: {
        fontSize: 24
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    headerMoneyText: {
        fontSize: 18
        , color: STYLES.LIGHT_GREEN
    },
    button: {
        alignSelf: 'flex-start'
        , borderWidth: 2
        , borderColor: STYLES.PRIMARY_TEXT_COLOR
        , borderRadius: 30
        , paddingVertical: 10
        , paddingHorizontal: 15
    },
    buttonText: {
        fontSize: 16
        , fontWeight: 'bold'
        , color: STYLES.PRIMARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/components/card/index.js